module.exports = __webpack_public_path__ + "img/LUX map icon online.667fbde5.png";